import * as React from "react";
import {InputTypes} from "../../../components/FormStepper/InputTypes";
import FormStepper from "../../../components/FormStepper/FormStepper";
import FormUtils from "../../../FormUtils";
import {LeadPlanType} from "shared/functions/membersApi/types/ISignupProcess";
import ResetFormBtn from "../../../../../components/ResetForm/resetFormBtn";
import FormButton from "../../../../../components/FormButton/FormButton";
import {FormComponent} from "../../../state/FormsState";
import {CoverageState} from "../../../state/CoverageState";
import {AnalyticsSignUpEvents} from "../../../../../services/Analytics/AnalyticsSignUpEvents";
import MixPanelAnalyticsService from "../../../../../services/Analytics/MixPanelAnalyticsService";
import FBPixelService from "../../../../../services/Analytics/FBPixelService";

interface IProps {
    store: any;
    isCoverageSelection?: boolean;
}

interface ILocalState {
    selectedPlan: LeadPlanType | undefined;
}

const storePropertyName = "plans";
const TEXTS = {
    PLANS: {
        HEADER: {
            TITLE: "Plans",
            DESCRIPTION: "Select the right plan for your business."
        },
        SUB_HEADER: {
            TITLE: "What would you like  to do?",

        },
        DEPOSIT: {
            TITLE: "Waive a deposit",
            TEXT: "Salaryo will pay your office security deposit, or refund your paid deposit, for a small monthly fee."
        },
        RENT: {
            TITLE: "Skip rent",
            TEXT: "Skip next month's rent and break it into installments. Deskpass memberships accepted."
        },
        LOAN: {
            TITLE: "Business loan",
            TEXT: "Get a flexible loan and pay it back in monthly installments, for a small monthly fee."
        },
        DEPOSIT_AND_RENT: {
            TITLE: "Deposit + Skip rent",
            TEXT: "Get the best of both worlds and let Salaryo take care of all your office costs, for a small monthly fee."
        }
    }
}

export default class FormPlanSelector  extends React.Component<
    IProps,
    ILocalState
    > {

    public state: ILocalState = {
        selectedPlan: undefined
    };

    public plans: any = [
        {
            isHeader: true,
            title: TEXTS.PLANS.HEADER.TITLE,
            description: TEXTS.PLANS.HEADER.DESCRIPTION,
            inputType: InputTypes.none
        },
        {
            title:  TEXTS.PLANS.SUB_HEADER.TITLE,
            inputType: InputTypes.cardsSelect,
            options: [],
            propName: "plansValue"

        }
    ];
    constructor (props: IProps) {
        super(props);
        FormUtils.setFormNavigationOnInit(storePropertyName, props.store);
    }

    public updateSelected = (val: LeadPlanType) => {
        FBPixelService.track(val);
        const {store} = this.props;
        const newState = this.state;
        newState.selectedPlan = val;
        this.setState(newState);
        store.formInput.plans.plansValue = this.state.selectedPlan;

    };

    public isSelected(val: LeadPlanType) {
        return this.state.selectedPlan === val;
    }

    public renderNextButton = () => {
        const classes = this.state.selectedPlan? "blue" : "disabled";
        return <FormButton click={this.navigateForward} btnText={'Next'} classes={classes}/>
    };

    public navigateBack = () => {
        const {store} = this.props;
        store.updateCurrentComponent(FormComponent.welcome);
    };

    public navigateForward = () => {
        const {store, isCoverageSelection} = this.props;
        if(this.state.selectedPlan) {
            FBPixelService.track(this.state.selectedPlan);
            MixPanelAnalyticsService.track(AnalyticsSignUpEvents.PlanSelected, {plan: this.state.selectedPlan});
            if(isCoverageSelection) {
                if(store.formInput.plans.plansValue === LeadPlanType.Rent || store.formInput.plans.plansValue === LeadPlanType.Loan) {
                    store.updateScreen(CoverageState.financial);
                }
            }else {
                store.updateCurrentComponent(FormComponent.business);
            }
        }
    };

    public render() {
        const {store, isCoverageSelection} = this.props;
        const options = [
            {
                isSelected: this.isSelected(LeadPlanType.Deposit),
                title: TEXTS.PLANS.DEPOSIT.TITLE,
                text: TEXTS.PLANS.DEPOSIT.TEXT,
                click: () => this.updateSelected(LeadPlanType.Deposit)
            },
            {
                isSelected: this.isSelected(LeadPlanType.Rent),
                title: TEXTS.PLANS.RENT.TITLE,
                text: TEXTS.PLANS.RENT.TEXT,
                click: () => this.updateSelected(LeadPlanType.Rent)
            },
            {
                isSelected: this.isSelected(LeadPlanType.Loan),
                title: TEXTS.PLANS.LOAN.TITLE,
                text: TEXTS.PLANS.LOAN.TEXT,
                click: () => this.updateSelected(LeadPlanType.Loan)
            }

        ];
        this.plans[1].options = options;
        return(
            <>
                <div className="form-steps-container"> <FormStepper navigationProperty={storePropertyName} steps={this.plans} store={store}/></div>
                <div className="form-navigation">
                    {isCoverageSelection? null : <div className="start-over-container"><ResetFormBtn/></div>}
                    <div className={"link-next" + (isCoverageSelection ? ' align-right' : '')}>{this.renderNextButton()}</div>
                </div>
            </>
        )

    };
}


// WEBPACK FOOTER //
// ./src/scenes/Forms/screens/SignUpForm/FormPlanSelector/FormPlanSelector.tsx